<template>
  <v-container>
    <v-slide-y-transition mode="out-in">
      <v-layout column>
        <v-flex xs12 sm6>
          <v-btn @click="login">Login with Google</v-btn>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
  export default {
    name: 'login',
    components: {},
    data() {
      return {};
    },
    mounted() {
      this.$auth().onAuthStateChanged((user) => {
        if (user) {
          this.$router.push('Home');
        }
      });
    },
    methods: {
      login() {
        const provider = new this.$auth.GoogleAuthProvider();
        this.$auth()
            .signInWithPopup(provider)
            .then(() => {
              console.log('Logged');
            })
            .catch((error) => {
              console.log(error.code, error.message, error.email);
            });
      },
    },
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Login.vue